/* eslint-disable no-unused-vars */

import chart from "../chart";
import { select, selectAll } from "d3-selection";
import { scaleOrdinal, scaleLinear, scaleTime } from "d3-scale";
import { timeParse, timeFormat } from "d3-time-format";
import { timeDay, timeDays, timeWeek } from "d3-time";
import { min, max, extent } from "d3-array";
import { line, area } from "d3-shape";
import { transition } from "d3-transition";
import { axisLeft, axisBottom } from "d3-axis";
import { keys } from "d3-collection";
import {
  easeLinear,
  easePolyIn,
  easePolyOut,
  easePoly,
  easePolyInOut,
  easeQuadIn,
  easeQuadOut,
  easeQuad,
  easeQuadInOut,
  easeCubicIn,
  easeCubicOut,
  easeCubic,
  easeCubicInOut,
  easeSinIn,
  easeSinOut,
  easeSin,
  easeSinInOut,
  easeExpIn,
  easeExpOut,
  easeExp,
  easeExpInOut,
  easeCircleIn,
  easeCircleOut,
  easeCircle,
  easeCircleInOut,
  easeElasticIn,
  easeElastic,
  easeElasticOut,
  easeElasticInOut,
  easeBackIn,
  easeBackOut,
  easeBack,
  easeBackInOut,
  easeBounceIn,
  easeBounce,
  easeBounceOut,
  easeBounceInOut,
} from "d3-ease";
import {
  curveBasis,
  curveBundle,
  curveCardinal,
  curveCatmullRom,
  curveLinear,
  curveMonotoneX,
  curveMonotoneY,
  curveNatural,
  curveStep,
  curveStepAfter,
  curveStepBefore,
} from "d3-shape"; // Curve variables
import {
  schemeCategory10,
  schemeAccent,
  schemeDark2,
  schemePaired,
  schemePastel1,
  schemePastel2,
  schemeSet1,
  schemeSet2,
  schemeSet3,
  schemeTableau10,
} from "d3-scale-chromatic";
import { brushX } from "d3-brush";
import { event, mouse, scan } from "d3";

const d3 = {
  mouse,
  scan,
  select,
  selectAll,
  scaleOrdinal,
  scaleLinear,
  scaleTime,
  timeParse,
  timeFormat,
  max,
  min,
  extent,
  line,
  area,
  transition,
  axisLeft,
  timeDay,
  timeWeek,
  axisBottom,
  easeLinear,
  easePolyIn,
  easePolyOut,
  easePoly,
  easePolyInOut,
  easeQuadIn,
  easeQuadOut,
  easeQuad,
  easeQuadInOut,
  easeCubicIn,
  easeCubicOut,
  easeCubic,
  easeCubicInOut,
  easeSinIn,
  easeSinOut,
  easeSin,
  easeSinInOut,
  easeExpIn,
  easeExpOut,
  easeExp,
  easeExpInOut,
  easeCircleIn,
  easeCircleOut,
  easeCircle,
  easeCircleInOut,
  easeElasticIn,
  easeElastic,
  easeElasticOut,
  easeElasticInOut,
  easeBackIn,
  easeBackOut,
  easeBack,
  easeBackInOut,
  easeBounceIn,
  easeBounce,
  easeBounceOut,
  easeBounceInOut,
  curveBasis,
  curveBundle,
  curveCardinal,
  curveCatmullRom,
  curveLinear,
  curveMonotoneX,
  curveMonotoneY,
  curveNatural,
  curveStep,
  curveStepAfter,
  curveStepBefore,
  schemeCategory10,
  schemeAccent,
  schemeDark2,
  schemePaired,
  schemePastel1,
  schemePastel2,
  schemeSet1,
  schemeSet2,
  schemeSet3,
  schemeTableau10,
  keys,
};

class forcastchart extends chart {
  constructor(selection, data, config) {
    super(selection, data, config, {
      margin: { top: 20, right: 20, bottom: 20, left: 40 },
      values: [],
      date: { key: false, inputFormat: "%Y-%m-%d", outputFormat: "%Y-%m-%d" },
      color: {
        key: false,
        keys: false,
        scheme: false,
        current: "#1f77b4",
        default: "#AAA",
        axis: "#fff",
      },
      curve: "curveLinear",
      points: { visibleSize: 3, hoverSize: 6 },
      axis: {
        yTitle: false,
        xTitle: false,
        yFormat: ".0f",
        xFormat: "%Y-%m-%d",
        yTicks: 5,
        xTicks: 3,
      },
      tooltip: { labels: false },
      transition: { duration: 350, ease: "easeLinear" },
      idleTimeout: undefined,
      brush: undefined,
      clipName: "clip",
      classesNamesLines: {
        actualHist: "chart__line",
        forecastNoAction: "chart__line__Forecast__noAction",
        forecastData: "chart__lineForcast",
        dateline: "chart__dateLine",
      },
      classesNamesAreas: {
        actualHist: "chart__area",
        forecastNoAction: "chart__area__Forecast__noAction",
        forecastData: "chart__areaFor",
      },
    });
  }

  /**
   * Init chart
   */
  initChart() {
    // Set up dimensions

    this.initChartFrame("areachart");
    this.getDimensions();

    // Format date functions
    this.parseTime = d3.timeParse(this.cfg.date.inputFormat);
    this.formatTime = d3.timeFormat(this.cfg.date.outputFormat);

    // Init scales
    this.yScale = d3.scaleLinear();
    this.xScale = d3.scaleTime();
    this.line = d3.line();
    this.area = d3.area();

    // Axis group
    this.axisg = this.g
      .append("g")
      .attr("class", "chart__axis chart__axis--areachart");

    // Horizontal grid
    this.yGrid = this.axisg
      .append("g")
      .attr("class", "chart__grid chart__grid--y chart__grid--areachart");

    // Bottom axis
    this.xAxis = this.axisg
      .append("g")
      .attr("class", "chart__axis-x chart__axis-x--areachart");

    // Vertical axis
    this.yAxis = this.axisg
      .append("g")
      .attr("class", "chart__axis-y chart__axis-y--areachart chart__grid");

    // Vertical axis title
    if (this.cfg.axis.yTitle)
      this.yAxisTitle = this.axisg
        .append("text")
        .attr("class", "chart__axis-title chart__axis-title--areachart")
        .attr("transform", "rotate(-90)")
        .style("text-anchor", "middle");

    //lines and areas group
    this.pathsGroup = this.g.append("g").attr("class", "chart__paths");

    // Set transition
    this.transition = d3
      .transition("t")
      .duration(this.cfg.transition.duration)
      .ease(d3[this.cfg.transition.ease]);

    this.setChartDimension();
    this.updateChart();

    this.brush = brushX() // Add the brush feature using the d3.brush function
      .extent([
        [0, 0],
        [this.cfg.width, this.cfg.height],
      ])
      .on("end", this.updateByBrush.bind(this));

    this.g
      .select(".chart__paths")
      .append("g")
      .attr("class", "brush")
      .call(this.brush);

    this.focusPoint = this.g
      .select(".chart__paths")
      .append("g")
      .attr("class", "focuspoint")
      .append("circle")
      .style("fill", "none")
      .attr("stroke", "none")
      .attr("r", 4)
      .style("opacity", 0);

    this.simpletooltip = this.g
      .select(".chart__paths")
      .append("g")
      .style("z-index", "10")
      .style("visibility", "hidden")
      .style("background", "#000")
      .attr("class", "simpletooltip");

    this.simpletooltip
      .append("rect")
      .attr("x", -5)
      .attr("y", -15)
      .attr("width", 80)
      .attr("height", 20)
      .attr("rx", 6)
      .attr("ry", 6)
      .style("fill", "white")
      .style("opacity", 0.7)
      .style("stroke", "black")
      .style("stroke-width", 1);

    this.simpletooltip
      .append("text")
      .style("fill", "black")
      .style("font-size", "12px")
      .style("border", ":2px black solid")
      .attr("x", 0)
      .attr("y", 0)
      .text("a simple tooltip");

    this.addTooltipAndFocusPt();

    let clip = this.g
      .selectAll(".chart__paths")
      // .append("defs")
      .append("clipPath")
      .attr("id", this.cfg.clipName)
      .append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", this.cfg.width)
      .attr("height", this.cfg.height);
  }

  addTooltipAndFocusPt() {
    this.g
      .select("g.brush")
      .on("mousemove", (d, i, nodes) => {
        // console.log(d3.mouse(nodes[i]));
        const mousePosition = d3.mouse(nodes[i]);

        // console.log("mousePosition ", mousePosition);

        const hoveredDate = this.xScale.invert(mousePosition[0]);
        // console.log("hoveredDate ", hoveredDate);

        const hoveredY = this.yScale.invert(mousePosition[1]);
        // console.log("hoveredY", hoveredY);

        const getDistanceFromHoveredDate = (d) => Math.abs(d.x - hoveredDate);
        const closestIndexActualHist = d3.scan(
          this.chartData.actualHist,
          (a, b) =>
            getDistanceFromHoveredDate(a) - getDistanceFromHoveredDate(b)
        );
        // console.log("closestIndexActualHist ", closestIndexActualHist);

        const closestForecastNoAction = d3.scan(
          this.chartData.forecastNoAction,
          (a, b) =>
            getDistanceFromHoveredDate(a) - getDistanceFromHoveredDate(b)
        );

        const closestTFostcastData = d3.scan(
          this.chartData.forecastData,
          (a, b) =>
            getDistanceFromHoveredDate(a) - getDistanceFromHoveredDate(b)
        );
        // console.log("closestTFostcastData", closestTFostcastData);

        let distanceFromclosestIndexActualHist = Infinity;
        let distanceFromclosestTFostcastDatat = Infinity;
        let distanceFromclosestForecastNoAction = Infinity;

        if (closestIndexActualHist)
          if (
            closestIndexActualHist > 0 &&
            closestIndexActualHist < this.chartData.actualHist.length - 1
          ) {
            const closestYValue =
              this.chartData.actualHist[closestIndexActualHist].y;
            distanceFromclosestIndexActualHist = Math.sqrt(
              Math.pow(closestYValue - hoveredY, 2)
            );
          }

        if (closestForecastNoAction)
          if (
            closestForecastNoAction > 0 &&
            closestForecastNoAction <
              this.chartData["forecastNoAction"].length - 1
          ) {
            const closestYValue =
              this.chartData["forecastNoAction"][closestForecastNoAction].y;
            distanceFromclosestForecastNoAction = Math.sqrt(
              Math.pow(closestYValue - hoveredY, 2)
            );
          }

        if (closestTFostcastData)
          if (
            closestTFostcastData > 0 &&
            closestTFostcastData < this.chartData["forecastData"].length - 1
          ) {
            const closestYValue =
              this.chartData["forecastData"][closestTFostcastData].y;
            distanceFromclosestTFostcastDatat = Math.sqrt(
              Math.pow(closestYValue - hoveredY, 2)
            );
          }

        let minDist = Math.min(
          this.checkForUndefinedMin(distanceFromclosestIndexActualHist),
          this.checkForUndefinedMin(distanceFromclosestTFostcastDatat),
          this.checkForUndefinedMin(distanceFromclosestForecastNoAction)
        );

        // //only display the closest

        // console.log("minDist ", minDist);

        if (minDist === distanceFromclosestIndexActualHist) {
          //tooltip for actual value
          const closestDataPoint =
            this.chartData.actualHist[closestIndexActualHist];
          // console.table(closestDataPoint);
          this.createTooltip(
            closestDataPoint,
            this.cfg.color.scheme[0],
            20,
            30
          );
          this.focusPoint.style("fill", this.cfg.color.scheme[0]);
          this.focusPoint.style("opacity", 1);
          this.focusPoint
            .attr("cx", this.xScale(closestDataPoint.x))
            .attr("cy", this.yScale(closestDataPoint.y));
        } else if (minDist === distanceFromclosestForecastNoAction) {
          const closestDataPoint =
            this.chartData["forecastNoAction"][closestForecastNoAction];
          this.createTooltip(
            closestDataPoint,
            this.cfg.color.scheme[0],
            40,
            30
          );
          this.focusPoint.style("fill", this.cfg.color.scheme[0]);
          this.focusPoint.style("opacity", 1);
          this.focusPoint
            .attr("cx", this.xScale(closestDataPoint.x))
            .attr("cy", this.yScale(closestDataPoint.y));
        } else if (minDist === distanceFromclosestTFostcastDatat) {
          const closestDataPoint =
            this.chartData["forecastData"][closestTFostcastData];
          this.createTooltip(
            closestDataPoint,
            this.cfg.color.scheme[1],
            40,
            30
          );
          this.focusPoint.style("fill", this.cfg.color.scheme[1]);
          this.focusPoint.style("opacity", 1);
          this.focusPoint
            .attr("cx", this.xScale(closestDataPoint.x))
            .attr("cy", this.yScale(closestDataPoint.y));
        } else {
          // this.tooltip.classed("active", false);
          this.simpletooltip.style("visibility", "hidden");
          this.focusPoint.style("opacity", 0);
        }
      })
      .on("mouseout", (_) => {
        // this.tooltip.classed("active", false);
        this.simpletooltip.style("visibility", "hidden");
        this.focusPoint.style("opacity", 0);
      });
  }

  createTooltip(closestDataPoint, color, xDisplacement = 0, yDisplacement = 0) {
    const closestXValue = closestDataPoint.x;
    const closestYValue = closestDataPoint.y;

    const x = this.xScale(closestXValue) + this.cfg.margin.left;
    const y = this.cfg.height - this.yScale(closestYValue); // + this.cfg.margin.top;

    const formatDate = d3.timeFormat("%b %-d");

    this.simpletooltip
      .select("text")
      .style("fill", color)
      .text(formatDate(closestXValue) + ": " + closestYValue.toFixed(0));

    // console.log(this.simpletooltip.select("text").node().getBBox()); //get bounding box

    let bbwidth = this.simpletooltip.select("text").node().getBBox().width;
    this.simpletooltip.select("rect").attr("width", bbwidth + 10);

    this.simpletooltip.style("visibility", "visible");

    this.simpletooltip.style(
      "transform",
      `translate(` +
        `${this.xScale(closestDataPoint.x) - xDisplacement}px,` +
        `${this.yScale(closestDataPoint.y) + yDisplacement}px` +
        `)`
    );
  }

  updateByBrush(e, d) {
    // console.log(e);
    // console.log(d);
    let extent = event.selection;
    // console.log(extent);
    // console.log("idleTimeout", this.idleTimeout);

    if (!extent) {
      if (!this.idleTimeout)
        return (this.idleTimeout = setTimeout(() => this.idled(), 350)); // This allows to wait a little bit

      this.setXscale();
      // console.log("resize happened________________");
    } else {
      this.xScale.domain([
        this.xScale.invert(extent[0]),
        this.xScale.invert(extent[1]),
      ]);
      this.g
        .select(".chart__paths")
        .select(".brush")
        .call(this.brush.move, null); // This remove the grey brush area as soon as the selection has been done
    }
    //zoom

    let t = this.svg.transition().duration(1000);
    this.xAxis
      // .attr("transform", `translate(0,${this.cfg.height})`)
      .transition(t)
      .call(
        d3
          .axisBottom(this.xScale)
          .tickFormat(this.formatTime)
          .ticks(this.cfg.axis.xTicks, this.cfg.axis.xFormat)
      );
    // this.resizeChart();
    this.updateElements();
  }

  // A function that set idleTimeOut to null
  idled() {
    this.idleTimeout = null;
    // console.log("indeled was called");
    // console.log(this);
    // console.log("after Idled() ", this.idleTimeout);
  }

  /**
   * Calcule required derivated data
   */
  computeData() {
    // Calcule transpose data
    const chartData = {
      actualHist: [],
      forecastNoAction: [],
      forecastData: [],
    };

    this.data.historical.forEach((d) => {
      d.x = this.parseTime(d[this.cfg.date.key]);
    });
    this.data.historical.sort((a, b) => a.jsdate - b.jsdate);

    chartData.actualHist = this.data.historical;

    this.data.forcastednoaction.forEach((d) => {
      d.x = this.parseTime(d[this.cfg.date.key]);
    });
    this.data.forcastednoaction.sort((a, b) => a.jsdate - b.jsdate);

    chartData.forecastNoAction = this.data.forcastednoaction;

    this.data.forecastData.forEach((d) => {
      d.x = this.parseTime(d[this.cfg.date.key]);
    });
    this.data.forecastData.sort((a, b) => a.jsdate - b.jsdate);
    chartData.forecastData = this.data.forecastData;

    this.chartData = chartData;
  }

  /**
   * Set up chart dimensions (non depending on data)
   */
  setChartDimension() {
    // Resize SVG element
    this.svg
      .attr(
        "viewBox",
        `0 0 ${this.cfg.width + this.cfg.margin.left + this.cfg.margin.right} ${
          this.cfg.height + this.cfg.margin.top + this.cfg.margin.bottom
        }`
      )
      .attr(
        "width",
        this.cfg.width + this.cfg.margin.left + this.cfg.margin.right
      )
      .attr(
        "height",
        this.cfg.height + this.cfg.margin.top + this.cfg.margin.bottom
      );

    // Vertical axis title
    if (this.cfg.axis.yTitle)
      this.yAxisTitle
        .attr("y", -this.cfg.margin.left + 10)
        .attr("x", -this.cfg.height / 2)
        .text(this.cfg.axis.yTitle);
  }

  checkForUndefinedMax(val) {
    return isNaN(val) ? -Infinity : val;
  }

  checkForUndefinedMin(val) {
    return isNaN(val) ? Infinity : val;
  }

  /**
   * Set up scales
   */
  setScales() {
    // Calcule vertical scale
    this.setYscale();
    // Calcule horizontal scale
    this.setXscale();

    if (this.cfg.color.scheme instanceof Array === true) {
      this.colorScale = d3.scaleOrdinal().range(this.cfg.color.scheme);
    } else if (typeof this.cfg.color.scheme === "string") {
      this.colorScale = d3.scaleOrdinal(d3[this.cfg.color.scheme]);
    }

    // Set up line function
    this.line
      .x((d) => this.xScale(d.x))
      .y((d) => this.yScale(d.y))
      .curve(d3[this.cfg.curve]);

    // Set up area function
    this.area
      .x((d) => this.xScale(d.x))
      .y0((d) => this.yScale(d.y0))
      .y1((d) => this.yScale(d.y1))
      .curve(d3[this.cfg.curve]);

    // Redraw grid
    this.yGrid.call(
      d3
        .axisLeft(this.yScale)
        .tickSize(-this.cfg.width)
        .ticks(this.cfg.axis.yTicks, this.cfg.axis.yFormat)
    );

    // Redraw horizontal axis
    this.xAxis.attr("transform", `translate(0,${this.cfg.height})`).call(
      d3
        .axisBottom(this.xScale)
        .tickFormat(this.formatTime)
        //   .ticks(this.cfg.axis.xTicks, this.cfg.axis.xFormat)
        // .ticks(d3.timeWeek.every(3))
        .ticks(this.cfg.axis.xTicks, this.cfg.axis.xFormat)
    );
  }

  /**
   * Set x scale
   */
  setXscale() {
    let today = new Date();

    let maxXhist = d3.max(this.chartData.actualHist, (d) => d.x);
    let minXhist = d3.min(this.chartData.actualHist, (d) => d.x);

    let maxXforecastNoAction = d3.max(
      this.chartData.forecastNoAction,
      (d) => d.x
    );
    let minXforecastNoAction = d3.min(
      this.chartData.forecastNoAction,
      (d) => d.x
    );

    let maxXforecast = -Infinity;
    let minXforecast = Infinity;

    if (this.chartData.forecastData.length) {
      maxXforecast = d3.max(this.chartData.forecastData, (d) => d.x);
      minXforecast = d3.min(this.chartData.forecastData, (d) => d.x);
    }

    let maxX = Math.max(
      this.checkForUndefinedMax(maxXhist),
      this.checkForUndefinedMax(maxXforecastNoAction),
      this.checkForUndefinedMax(maxXforecast),
      today
    );

    let minX = Math.min(
      this.checkForUndefinedMin(minXhist),
      this.checkForUndefinedMin(minXforecastNoAction),
      this.checkForUndefinedMin(minXforecast),
      today
    );

    this.xScale.domain([minX, maxX]).rangeRound([0, this.cfg.width]);
  }

  /**
   * Set y scale
   */
  setYscale() {
    let maxHist = d3.max(this.chartData.actualHist, (d) => d.y1);
    let maxForecastNoAction = d3.max(
      this.chartData.forecastNoAction,
      (d) => d.y1
    );

    let maxDataForcast = -Infinity;

    if (this.chartData.forecastData.length) {
      maxDataForcast = d3.max(this.chartData.forecastData, (d) => d.y1);
    }

    let maxY = Math.max(
      this.checkForUndefinedMax(maxHist),
      this.checkForUndefinedMax(maxForecastNoAction),
      this.checkForUndefinedMax(maxDataForcast)
    );
    maxY += maxY * 0.1;

    this.yScale.domain([0, maxY]).rangeRound([this.cfg.height, 0]);
  }

  /**
   * Bind data to main elements groups
   */
  bindData() {}

  /**
   * Update chart's elements based on data change
   */
  updateElements() {
    let today = new Date();
    let x = [today, today];
    let y = [0, this.yScale.domain()[1]];
    let dateLineData = x.map((v, i) => {
      return {
        x: v,
        y: y[i],
      };
    });
    // Lines
    let linesGroup = this.pathsGroup
      .selectAll(".line-group")
      .data(
        [...Object.entries(this.chartData), ["dateline", dateLineData]],
        (d) => {
          // console.log(d);
          return d[0] + d[1].length;
        }
      );
    linesGroup.exit().remove();
    linesGroup.interrupt("t");

    const newLinesgroups = linesGroup.enter();
    newLinesgroups
      .append("path")
      .merge(linesGroup)
      .attr("class", (d) => {
        return this.cfg.classesNamesLines[d[0]];
      })
      .classed("line-group", true)
      .attr("fill", "transparent")
      .attr("clip-path", "url(#" + this.cfg.clipName + ")")
      .transition(this.transition)
      .attr("d", (d) => {
        // console.log("****** ", d);
        return this.line(d[1]);
      });

    //Areas
    let areasGroup = this.pathsGroup
      .selectAll(".area-group")
      .data(Object.entries(this.chartData), (d) => {
        // console.log(d);
        return d[0] + d[1].length;
      });
    areasGroup.exit().remove();
    areasGroup.interrupt("t");

    const newAreasGroup = areasGroup.enter();
    newAreasGroup
      .append("path")
      .merge(areasGroup)
      .attr("class", (d) => {
        return this.cfg.classesNamesAreas[d[0]];
      })
      .classed("area-group", true)
      .attr("fill", "transparent")
      .attr("clip-path", "url(#" + this.cfg.clipName + ")")
      .transition(this.transition)
      .attr("d", (d) => this.area(d[1]));
  }

  /**
   * Update brush and clip
   */
  updateBrushClipArea() {
    this.g
      .select("#" + this.cfg.clipName)
      .select("rect")
      .attr("width", this.cfg.width)
      .attr("height", this.cfg.height);
    this.brush.extent([
      [0, 0],
      [this.cfg.width, this.cfg.height],
    ]);
    this.g.select(".chart__paths").select("g.brush").call(this.brush);
    this.g
      .select(".chart__paths")
      .select("g.brush")
      .call(this.brush.move, null);
  }

  /**
   * Resize chart methods
   */
  resizeChart() {
    this.getDimensions();
    this.setScales();
    this.setChartDimension();
    this.updateElements();
    this.updateBrushClipArea();
  }
}

export default forcastchart;
